angular.module('cvsApp').service('verifyAnswerServicev1', ['networkService', 'xdrService', 'configManager', 
'verifyAnswerModelv1', 'cvsAppData', '$base64', function (NS, XS, CM, VASM, CAD, $base64) {

    function verifyAnswer() {
        this.verifyAnswer = function (callBackSuccess, oVerifyAnswer) {
            //get url
            // var tokenId = CAD.getTokenId();
            // var tokenType = CAD.getTokenType();
            var apikey = CAD.getApiKey();
            //var url = CM.getAGPAPIUrl('VERIFY_ANSWER_V1');
            var url = CVS.Config.serviceHost[cvsUtility.queryMap.env]+"SPLAGPv1/userAuthentication/verifyAnswers/v3"
            if(cvsUtility.queryMap.env === 'local'){
				url = CVS.Config.serviceHost[cvsUtility.queryMap.env] + "specialty/SPLAGPv1/userAuthentication/verifyAnswers/v3";
			}

            // url = url + "&tokenID=" + oVerifyAnswer.tokenID + "&tokenType=SPLPAS";
            if (url === "URL_ERROR") {

            } else {

                //var url = cvsUtility.updateQueryParam(url, 'appName', 'Portal');
                var request = {
                    url: url,
                    header: {
                        'Content-Type': 'application/xml',
                        'accept': 'application/xml'
                    },
                    data: requestBody(oVerifyAnswer),
                    onSuccess: callBackSuccess
                }
                    cvsUtility.commonServiceCode(url, "verifyAnswerV1", VASM, request, callBackSuccess, NS);
            }

        }

        var requestBody = function (oVerifyAnswer) {
            


                var apikey = CAD.getApiKey();
            var reqObj = {
                "verifyAnswersRequest": {
                    "header": {
                        "serviceContext": {
                            "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                            "lineOfBusiness": "Specialty",
                            "channelName": cvsUtility.queryMap.channel,
                            "responseFormat": "XML",
                            "tokenID": oVerifyAnswer.tokenID,
                            "tokenType": CAD.getTokenType()
                        },
                        "securityContext": {
                            "apiKey": apikey,
                            "securityType": "apiKey"
                        }
                    },
                    "details": {
                        "challengeAnswer": {
                            "answer": {
                                "questionId": oVerifyAnswer.questionID,
                                "answerText": $base64.encode(oVerifyAnswer.answer),
                            }
                        },
                        "flowType": CAD.getFlowType()
                    }
                }
            };
            var x2js = new X2JS();
            return x2js.json2xml_str(reqObj);
            };



    }

    return new verifyAnswer();
}]);